import React from 'react';
import {
	LegacyFormNumberField,
	type LegacyFormNumberFieldProps,
} from '@netx/core-components/Form/NumberField';
import type {ICustomFormItem} from '../../types';
import {
	getCustomFormItemTranslatedLabel,
	getCustomFormBaseFieldName,
} from '../../utils';

export interface LegacyFormCustomFormItemNumberProps
	extends Omit<LegacyFormNumberFieldProps, 'label' | 'name' | 'required'> {
	item: ICustomFormItem<'number'>;
}

export const LegacyFormCustomFormItemNumberPrimitive = ({
	item,
	...props
}: LegacyFormCustomFormItemNumberProps) => {
	const {label, required} = item;

	return (
		<LegacyFormNumberField
			fullWidth
			{...props}
			label={getCustomFormItemTranslatedLabel(label)}
			name={getCustomFormBaseFieldName(item)}
			required={required}
		/>
	);
};

export const LegacyFormCustomFormItemNumber =
	LegacyFormCustomFormItemNumberPrimitive;

export default LegacyFormCustomFormItemNumber;
